<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Reports
</div>
<p-card>
    <form [formGroup]="filterDataForm">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-3">
                <label for="QueryType" class="required-field">Reports : </label>
                <div>
                    <p-dropdown formControlName="reports" placeholder="Select Report Type" styleClass="w-9" name="reports"
                        [options]="reportsList" optionLabel="name" (onChange)="onChangeReport($event)">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="partnerId" class="">Partner ID : </label>
                <div>
                    <p-dropdown name="partnerId" placeholder="ALL" styleClass="w-9" [filter]="true"
                        [options]="partnerDetails" optionLabel="partnerId" optionValue="partnerId" formControlName="partnerId" [showClear]="true">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="startDate" class="required-field">Start Date : </label>
                <div>
                    <p-calendar formControlName="startDate" styleClass="w-9" appendTo="body" hourFormat="24"
                        [showIcon]="true" dateFormat="MM dd yy" (onSelect)="validateStartDate($event)"
                        [maxDate]="maxScheduledStartDate" [readonlyInput]="true">
                    </p-calendar>
                </div>

            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="endDate" class="">End Date : </label>
                <div>
                    <p-calendar formControlName="endDate" styleClass="w-9" appendTo="body" hourFormat="24"
                        [showIcon]="true" (onSelect)="validateEndDate($event)" dateFormat="MM dd yy"
                        [maxDate]="maxScheduledEndDate" [readonlyInput]="true" [showButtonBar]="true">
                    </p-calendar>
                </div>

                <div>
                    <span class="error-msg" style="text-align:center">{{showMessage}}</span>
                </div>
            </div>
        </div>
        <div class="flex justify-content-center mt-2">
            <button pButton type="button" label="Generate Report" (click)="displayLog()"
                [disabled]="filterDataForm.invalid || showMessage"></button>
        </div>
    </form>
    
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
</p-confirmDialog>

    <div class="mt-2" *ngIf="isDataAvailable && !this.norecordsFound">
        <p-card>
            <div class="flex justify-content-end mb-2">
                <button pButton type="button" label="Export" (click)="exportExcel()"></button>
            </div>
            <div *ngIf="filterDataForm.value.reports.name === 'Test Activation'">
                <app-test-activation (eventVal)="onLazyLoad($event)" [testActivationReport]="testActivationReport" [totalRecords]="totalRecords" [column]="activationcolumn"></app-test-activation>
            </div>
            <div *ngIf="filterDataForm.value.reports.name === 'Customer Support Activation'">
                <app-customer-activation (eventVal)="onLazyLoad($event)" [customerActivationReport]="customerSupportActivation" [totalRecords]="totalRecords" [column]="customerColumn"></app-customer-activation>
            </div>

            <div *ngIf="filterDataForm.value.reports.name === 'Contract'">
                <app-contract-report (eventVal)="onLazyLoad($event)" [contractReport]="contractReport" [totalRecords]="totalRecords" [column]="contractColumn"></app-contract-report>
            </div>

        </p-card>
    </div>
</p-card>
<p *ngIf="norecordsFound" class="flex justify-content-center"> No Data Available</p>
<p-toast position="top-center" life="4000"></p-toast>
